<template>
  <div class="customer-list clearfix">
    <Search @handleSearch="handleSearch"
            @getHeight="getHeight"
            @add="addCustomer()"
            @saveSet="saveSet"
            :isquery="true"
            :isDel="false"
            :advancedQuery="false"
            :tableConfig="tableConfig"
            :tableName="tableName"
            :isSort="false"
            :showDel="false"
            :showSort="false"
            searchName="InsureUnitPage">
      <template v-slot:left>
        <el-col :lg="24"
                :md="24"
                :sm="24"
                :xs="24">
          <el-form-item label="关键字"
                        prop="keyWord">
            <el-input @keyup.enter.native="handleSearch"
                      v-model="searchForm.keyWord"
                      clearable
                      placeholder="请输入关键字查询"></el-input>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:center> </template>
    </Search>
    <div class="customer-table-list fr page">
      <MyTable @editCustomerInfo="editCustomerInfo"
               @selectChange="onlyChange"
               @inputChange="onlyChange"
               @selectionChange="selectionChange"
               :tableData="tableData"
               :tableConfig="tableConfig"
               :height="tableHeight"
               :indexFlag="true">
        <template v-slot:index="slotData">
          {{
            ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:isAuthentication="slotData">
          <el-tag size="small"
                  type="danger"
                  v-if="slotData.scope.row.isAuthentication == 0">未认证</el-tag>
          <el-tag size="small"
                  type="success"
                  v-else>已认证</el-tag>
        </template>
        <template v-slot:time="slotData">
          {{
            slotData.scope.row.createDate &&
            slotData.scope.row.createDate.slice(0, 10)
          }}
        </template>
        <template v-slot:sort="slotData">
          <el-input-number size="small"
                           :precision="0"
                           v-model="slotData.scope.row.sort"
                           controls-position="right"
                           @change="slotData.scope.row.add = '1'"></el-input-number>
        </template>

        <template v-slot:baseOperation="slotData">
          <el-button @click="editCustomerInfo(slotData.scope.row)"
                     plain
                     size="small"
                     icon="el-icon-edit">编辑</el-button>
          <!-- <el-button
            @click="editAccount(slotData.scope.row)"
            size="small"
            type="primary"
            plain
            icon="el-icon-edit"
            >设置账户</el-button
          > -->
          <el-button @click="deleteCustomer(slotData.scope.row.id)"
                     type="danger"
                     plain
                     size="small"
                     icon="el-icon-delete">删除</el-button>
        </template>
        <!-- <template v-slot:moreOperation="slotData">
        
        </template> -->
      </MyTable>
      <Pagination class="PagPosition"
                  :total="total"
                  @getNewData="InsureUnitPage"
                  ref="pagination" />
    </div>
    <AddCustomer :drawerShow="addCustomerDrawerShow"
                 :title="drawerTitle"
                 :operation="operation"
                 :customerInfo="customerInfo"
                 @colseDrawer="addCustomerDrawerShow = false"
                 @refreshData="
        () => {
          InsureUnitPage();
          // getCustomerLevelClassData();
        }
      " />
    <AddAccount @colseDrawer="addAccountDrawerShow = false"
                :visible.sync="addAccountDrawerShow"
                :onerow="onerow"
                @update="
        (flag) => {
          if (flag == false) {
            InsureUnitPage();
          }
        }
      " />
  </div>
</template>

<script>
import AddCustomer from "./AddCustomer";
import AddAccount from "./accountTable";
import MyTable from "@/components/Table";
import Search from "@/components/Search";

import { verifyPermissionMinix } from "@/utils/mixin";

export default {
  components: {
    Search,
    AddAccount,
    AddCustomer,
    MyTable,
  },
  mixins: [verifyPermissionMinix],

  data () {
    return {
      tableName: "UnitList",
      tableConfig: [
        {
          field: "name",
          label: "投保单位",
          flag: true,
          align: "center",
        },
        {
          field: "creditCode",
          label: "统一社会信用代码",
          flag: true,
          align: "center",
        },
        {
          field: "contactName",
          label: "联系人",
          align: "center",
          flag: true,
        },
        {
          field: "contactPhone",
          label: "手机号码",
          align: "center",
          flag: true,
        },
        // {
        //   field: "factoryCount",
        //   label: "单位数量",
        //   align: "center",
        //   flag: true,
        // },

        {
          label: "基本操作",
          slotName: "baseOperation",
          width: 180,
          align: "center",
          fixed: "right",
          flag: true,
        },
        // {
        //   label: "更多操作",
        //   slotName: "moreOperation",
        //   width: 120,
        //   fixed: "right",
        //   align: "center",
        //   flag: true,
        // },
      ],
      addCustomerDrawerShow: false,
      addAccountDrawerShow: false,
      drawerTitle: "",
      accountInfo: null,
      total: 0,
      loading: false,
      onerow: "",
      tableData: [{ customerName: "蓝龙人力" }],
      searchForm: {},
      customerIds: [],
      customerInfo: null,
      operation: "",
      companyId: "",
      tableHeight: "",
    };
  },
  computed: {},
  mounted () {
    this.InsureUnitPage();
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = this.sortType;
        }
      });
    }
  },
  methods: {
    onlyChange (value, field, row) {
      let sendData = {
        id: row.id,
        fieldName: field,
        fieldValue: value,
      };
      this.$api.customer.FactoryOneselfFieldChange(sendData).then((res) => {
        if (res.error) {
          this.$message.error(res.msg);
        }
      });
    },
    // 列的显示与隐藏
    saveSet (checkList, type) {
      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    //多选
    selectionChange (selection) {
      this.roastIds = selection.map((v) => {
        return v.Id;
      });
    },
    //获取子组件高度
    getHeight (height) {
      this.tableHeight = height;
    },

    //获取数据
    InsureUnitPage () {
      this.loading = true;
      const sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        keyWord: this.searchForm.keyWord,
      };

      this.$api.Insurance.InsureUnitPage(sendData).then((res) => {
        this.loading = false;
        if (res.error === false) {
          this.tableData = res.data.data;
          this.total = res.data.count;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 添加客户
    addCustomer (event) {
      this.operation = "add";
      this.addCustomerDrawerShow = true;
      this.drawerTitle = "新增投保单位";
    },
    // 删除公司
    deleteCustomer (id) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(5555);

          this.$api.Insurance.InsureUnitDelete([id]).then((res) => {

            if (res.error === false) {
              this.InsureUnitPage();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => { });
    },
    getCustomerDetails (id) {
      return new Promise((resolve, reject) => {
        let sendData = {
          id: id,
        };
        this.$api.Insurance.InsureUnitDetail(sendData).then((res) => {

          if (res.error === false) {
            resolve(res.data);
          } else {
            reject("error");
          }
        });
      });
    },
    // 打开添加驻场界面
    addOnSite (row) {
      this.operation = "check";
      this.addOnSiteShow = true;
      this.customerInfo = row;
    },
    // 修改公司信息
    editCustomerInfo (row) {
      this.getCustomerDetails(row.id).then((res) => {
        if (res) {

          this.operation = "edit";
          this.addCustomerDrawerShow = true;
          this.drawerTitle = "编辑投保单位";
          this.customerInfo = res;
        }
      });
    },
    // 设置账户
    editAccount (row) {
      // console.log(row.id);
      // this.getCustomerDetails(row.id).then((res) => {
      //   if (res) {
      //   
      //     this.operation = "edit";
      //     this.addCustomerDrawerShow = true;
      //     this.drawerTitle = "修改公司信息";
      //     this.customerInfo = res;
      //   }
      // });
      this.addAccountDrawerShow = true;
      this.onerow = row;
    },
    // 打开添加职位界面
    addPosition (companyId) {
      this.companyId = companyId;
      console.log(companyId);
      this.addPositionDrawerShow = true;
    },

    //查询
    handleSearch () {
      this.$refs.pagination.currentPage = 1;
      this.$refs.pagination.pageSize = 20;
      let sendData = "";
      if (this.searchForm.isCooperation != undefined) {
        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          keyWord: this.searchForm.keyWord,
          state: this.searchForm.isCooperation == 1 ? false : true,
        };
      } else {
        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          keyWord: this.searchForm.keyWord,
        };
      }
      if (sendData) {
        this.$api.customer.getCustomerData(sendData).then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.total = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.InsureUnitPage();
      }
    },
  },
};
</script>

<style lang="less">
// .el-form-item__label {
//   width: 60px !important;
// }
.top-buttons {
  transition: 1s;
}

.el-dropdown-link {
  margin-right: 10px;
}
.btn {
  margin-left: 15px;
}
.customer-list {
  .category {
    width: 200px;
    height: calc(100vh - 155px);
    background-color: #fff;
    border-radius: 6px;
    padding: 20px;
    margin-right: 20px;
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      font-size: 15px;
      img {
        width: 16px;
        margin-right: 5px;
      }
    }
    li {
      margin-top: 12px;
      cursor: pointer;
      &:hover {
        color: var(--theme-black);
        text-decoration: underline;
      }
    }
    .tab-active {
      color: #87481f !important;
      text-decoration: underline !important;
    }
  }
  .customer-table-list {
    width: calc(100%);
    height: calc(100vh - 140px);
  }
}
</style>
